import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Calculate nutritional values for a recipe
 * @param {string} recipeId - The recipe ID
 * @param {Array} ingredients - Array of ingredient objects with name, amount, unit
 * @param {number} servings - Number of servings
 * @returns {Promise<Object>} - Nutritional values per serving and total
 */
export async function calculateRecipeNutrition(recipeId, ingredients, servings) {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/recipes/${recipeId}/calculate-nutrition`,
            {
                ingredients: ingredients,
                servings: servings
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error calculating recipe nutrition:', error);
        throw error;
    }
}

/**
 * Format nutritional value for display
 * @param {string} key - The nutritional key (e.g., 'Calories', 'Protein')
 * @param {number} value - The nutritional value
 * @returns {string} - Formatted string with unit
 */
export function formatNutritionValue(key, value) {
    if (value === null || value === undefined || isNaN(value)) {
        return 'N/A';
    }

    // Sodium is in mg, others are in g
    if (key === 'Sodium') {
        return `${Math.round(value)} mg`;
    }
    
    // Round to 1 decimal place for most values
    if (key === 'Calories') {
        return `${Math.round(value)}`;
    }
    
    return `${parseFloat(value.toFixed(1))}g`;
}

